module.exports = __webpack_public_path__ + "static/media/icon29.862a3209.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon29.svg
// module id = 506
// module chunks = 0